import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Button,
  Form,
  Table,
  Row,
  Col,
  Badge,
  Card,
  Spinner,
  Alert,
  InputGroup,
  Dropdown,
  DropdownButton,
  Pagination,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Axios with token
import { getApiBase } from "../utils/useApiBase";
import axiosInstance from "../utils/axiosInstance";
import DateOfBirthInput from "../components/DateOfBirthInput";
const api = axiosInstance;



const API_URL = `${getApiBase()}/abaturage`;

// ─── Helper: safely convert any value to a renderable string ───
const safeString = (val) => {
  if (val === null || val === undefined) return "";
  if (typeof val === "string") return val;
  if (typeof val === "number" || typeof val === "boolean") return String(val);
  if (typeof val === "object") {
    // Handle SQL error objects from backend
    if (val.sqlMessage) return val.sqlMessage;
    if (val.message) return val.message;
    if (val.error && typeof val.error === "string") return val.error;
    try {
      return JSON.stringify(val);
    } catch {
      return "[Object]";
    }
  }
  return String(val);
};

// ─── Helper: extract error message from axios error ───
const extractErrorMessage = (err, fallback = "Habaye ikosa") => {
  if (!err) return fallback;
  const data = err.response?.data;
  if (!data) return err.message || fallback;
  if (typeof data === "string") return data;
  if (typeof data === "object") {
    if (data.sqlMessage) return data.sqlMessage;
    if (typeof data.error === "string") return data.error;
    if (data.error && typeof data.error === "object") {
      return data.error.sqlMessage || data.error.message || JSON.stringify(data.error);
    }
    if (data.message) return data.message;
    // The whole response might be a SQL error object
    if (data.code && data.errno) {
      return data.sqlMessage || `Database error: ${data.code}`;
    }
    try {
      return JSON.stringify(data);
    } catch {
      return fallback;
    }
  }
  return fallback;
};

const PHOTO_MAX_SIZE = 2 * 1024 * 1024;
const allowedPhotoTypes = new Set(["image/jpeg", "image/png"]);
const allowedPhotoExtensions = /\.(jpe?g|png)$/i;
const API_BASE = process.env.REACT_APP_API_URL || window.location.origin;
const getPhotoUrl = (filename) =>
  filename ? `${API_BASE}/uploads/photos/${filename}` : "";
const handleImgError = (e) => { e.target.style.display = "none"; if (e.target.nextSibling) e.target.nextSibling.style.display = "flex"; };

const Abaturage = ({ isUmudugudu = false }) => {
  // ────────────────────────────────────────────────
  // State
  // ────────────────────────────────────────────────
  const [abaturage, setAbaturage] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGender, setFilterGender] = useState("all");
  const [filterUbudehe, setFilterUbudehe] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stats, setStats] = useState({
    total: 0,
    male: 0,
    female: 0,
    present: 0,
    moved: 0,
    deceased: 0,
    ubudeheA: 0,
    ubudeheB: 0,
    ubudeheC: 0,
  });
  const [form, setForm] = useState({
    izina_ribanza: "",
    izina_risoza: "",
    igitsina: "",
    itariki_y_amavuko: "",
    indangamuntu: "",
    telefone: "",
    isibo_id: "",
    household_id: "",
    icyiciro_cy_imibereho: "",
    aho_ari: "Ariho",
    ifoto: "",
    imiterere_y_ubukwe: "Ingaragu",
    icyemezo_cy_ubukwe: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedCertFile, setSelectedCertFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  // ─── Responsive State ───────────────────────────────────
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [windowHeight, setWindowHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 800
  );
  const [orientation, setOrientation] = useState(
    typeof window !== "undefined" && window.innerWidth > window.innerHeight
      ? "landscape"
      : "portrait"
  );
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [mobileCardView, setMobileCardView] = useState(true);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const tableWrapperRef = useRef(null);
  const topRef = useRef(null);

  // ─── Breakpoint Helpers ─────────────────────────────────
  const isExtraSmall = windowWidth <= 360;
  const isSmall = windowWidth <= 576;
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;
  const isDesktop = windowWidth > 1024;
  const isLandscape = orientation === "landscape";
  const isShortScreen = windowHeight <= 500;

  // ─── Theme ──────────────────────────────────────────────
  const theme = {
    bg: "#F5F7FB",
    cardBg: "#ffffff",
    cardBgHover: "#f0f4fb",
    text: "#0B1F3B",
    textMuted: "#64748b",
    primary: "#0B3D91",
    primaryDark: "#093278",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626",
    info: "#0369a1",
    border: "#e2e8f0",
    tableBg: "#ffffff",
    tableHeaderBg: "#0B3D91",
    tableRowHover: "#EEF3FB",
  };

  const ubudeheCategories = [
    {
      value: "Arakize",
      label: "Arakize",
      color: "danger",
      icon: "exclamation-triangle-fill",
    },
    {
      value: "Arifashije",
      label: "Arifashije",
      color: "warning",
      icon: "dash-circle-fill",
    },
    {
      value: "Arakennye",
      label: "Arakennye",
      color: "info",
      icon: "circle-fill",
    },
  ];

  const statusConfig = {
    Ariho: {
      label: "Ariho",
      color: "success",
      icon: "house-check-fill",
    },
    Yimukiye_Ahandi: {
      label: "Yimukiye",
      color: "warning",
      icon: "box-arrow-right",
    },
    Yitabye_Imana: {
      label: "Yitabye Imana",
      color: "secondary",
      icon: "heart-fill",
    },
  };

  // ─── Responsive Detection ──────────────────────────────
  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      setWindowWidth(w);
      setWindowHeight(h);
      setOrientation(w > h ? "landscape" : "portrait");

      if (w <= 576) {
        setItemsPerPage(5);
        setMobileCardView(true);
      } else if (w <= 768) {
        setItemsPerPage(8);
        setMobileCardView(false);
      } else {
        setItemsPerPage(10);
        setMobileCardView(false);
      }
    };

    const handleOrientationChange = () => {
      setTimeout(handleResize, 150);
    };

    const handleFocusIn = (e) => {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.tagName === "SELECT"
      ) {
        if (window.innerWidth <= 768) {
          setKeyboardVisible(true);
        }
      }
    };

    const handleFocusOut = () => {
      setKeyboardVisible(false);
    };

    const handleViewportResize = () => {
      if (window.visualViewport) {
        const isKB = window.visualViewport.height < window.innerHeight * 0.75;
        setKeyboardVisible(isKB);
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportResize);
    }

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          handleViewportResize
        );
      }
    };
  }, []);

  // ─── Viewport & Safe Area Setup ─────────────────────────
  useEffect(() => {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      document.head.appendChild(viewportMeta);
    }
    viewportMeta.content =
      "width=device-width, initial-scale=1, maximum-scale=1, " +
      "user-scalable=no, viewport-fit=cover";

    let themeMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeMeta) {
      themeMeta = document.createElement("meta");
      themeMeta.name = "theme-color";
      document.head.appendChild(themeMeta);
    }
    themeMeta.content = theme.bg;

    
    document.body.style.backgroundColor = "#F5F7FB";

    return () => {
      document.body.style.overscrollBehavior = "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ────────────────────────────────────────────────
  // Helpers
  // ────────────────────────────────────────────────
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "—";
    return date.toLocaleDateString("rw-RW", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const calculateAge = (birthDate) => {
    if (!birthDate) return null;
    let birth;
    if (typeof birthDate === "string" && birthDate.includes("T")) {
      const datePart = birthDate.split("T")[0];
      const [year, month, day] = datePart.split("-").map(Number);
      birth = new Date(year, month - 1, day);
    } else if (typeof birthDate === "string" && birthDate.includes("-")) {
      const [year, month, day] = birthDate.split("-").map(Number);
      birth = new Date(year, month - 1, day);
    } else {
      birth = new Date(birthDate);
    }
    if (isNaN(birth.getTime())) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) age--;
    return age >= 0 ? age : 0;
  };

  const calculateStats = (data) => {
    if (!Array.isArray(data)) {
      setStats({
        total: 0, male: 0, female: 0, present: 0,
        moved: 0, deceased: 0, ubudeheA: 0, ubudeheB: 0, ubudeheC: 0,
      });
      return;
    }
    setStats({
      total: data.length,
      male: data.filter((a) => a.igitsina === "Gabo").length,
      female: data.filter((a) => a.igitsina === "Gore").length,
      present: data.filter((a) => a.aho_ari === "Ariho").length,
      moved: data.filter((a) => a.aho_ari === "Yimukiye_Ahandi").length,
      deceased: data.filter((a) => a.aho_ari === "Yitabye_Imana").length,
      ubudeheA: data.filter((a) => a.icyiciro_cy_imibereho === "Arakize").length,
      ubudeheB: data.filter((a) => a.icyiciro_cy_imibereho === "Arifashije").length,
      ubudeheC: data.filter((a) => a.icyiciro_cy_imibereho === "Arakennye").length,
    });
  };

  const showAlertMessage = (msg, variant = "success") => {
    // Always convert to string to prevent React rendering errors
    const safeMsg = safeString(msg);
    setAlert({ show: true, message: safeMsg, variant });
    setTimeout(
      () => setAlert({ show: false, message: "", variant: "" }),
      4500
    );
  };

  const resetForm = () => {
    setForm({
      izina_ribanza: "",
      izina_risoza: "",
      igitsina: "",
      itariki_y_amavuko: "",
      indangamuntu: "",
      telefone: "",
      isibo_id: "",
      household_id: "",
      icyiciro_cy_imibereho: "",
      aho_ari: "Ariho",
      ifoto: "",
      imiterere_y_ubukwe: "Ingaragu",
      icyemezo_cy_ubukwe: "",
    });
    setSelectedFile(null);
    setSelectedCertFile(null);
    setFormErrors({});
    setEditingId(null);
  };

  // ────────────────────────────────────────────────
  // Actions
  // ────────────────────────────────────────────────
  const exportToCSV = () => {
    if (!Array.isArray(filteredData) || filteredData.length === 0) {
      showAlertMessage("Nta makuru yo kohereza", "warning");
      return;
    }
    const headers = [
      "Izina Ribanza",
      "Izina Risoza",
      "Igitsina",
      "Itariki",
      "Imyaka",
      "Indangamuntu",
      "Telefoni",
      "Ubudehe",
      "Aho Ari",
    ];
    const csvData = filteredData.map((p) => [
      safeString(p.izina_ribanza),
      safeString(p.izina_risoza),
      safeString(p.igitsina),
      formatDateForInput(p.itariki_y_amavuko) || "",
      String(calculateAge(p.itariki_y_amavuko) || ""),
      safeString(p.indangamuntu),
      safeString(p.telefone),
      safeString(p.icyiciro_cy_imibereho),
      safeString(p.aho_ari),
    ]);
    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    );
    link.download = `abaturage_${new Date().toISOString().split("T")[0]}.csv`;
    link.click();
    showAlertMessage("Amakuru yakoreshejwe neza!", "success");
  };

  const handleViewDetails = (person) => {
    setSelectedPerson(person);
    setShowDetails(true);
  };

  const handleEdit = (person) => {
    setForm({
      izina_ribanza: safeString(person.izina_ribanza),
      izina_risoza: safeString(person.izina_risoza),
      igitsina: safeString(person.igitsina),
      itariki_y_amavuko: formatDateForInput(person.itariki_y_amavuko),
      indangamuntu: safeString(person.indangamuntu),
      telefone: safeString(person.telefone),
      isibo_id: safeString(person.isibo_id),
      household_id: safeString(person.household_id),
      icyiciro_cy_imibereho: safeString(person.icyiciro_cy_imibereho),
      aho_ari: safeString(person.aho_ari) || "Ariho",
      ifoto: safeString(person.ifoto),
      imiterere_y_ubukwe: safeString(person.imiterere_y_ubukwe) || "Ingaragu",
      icyemezo_cy_ubukwe: safeString(person.icyemezo_cy_ubukwe),
    });
    setSelectedFile(null);
    setSelectedCertFile(null);
    setEditingId(person.umuturage_id);
    setFormErrors({});
    setShow(true);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`${API_URL}/${deleteId}`);
      showAlertMessage("🗑️ Umuturage yasibwe burundu!", "success");
      fetchData();
      setShowDeleteModal(false);
    } catch (err) {
      showAlertMessage(
        extractErrorMessage(err, "Habaye ikosa mu gusiba umuturage"),
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!form.izina_ribanza.trim())
      errors.izina_ribanza = "Izina ribanza ni ngombwa";
    if (!form.izina_risoza.trim())
      errors.izina_risoza = "Izina risoza ni ngombwa";
    if (!form.igitsina) errors.igitsina = "Igitsina ni ngombwa";
    if (!form.itariki_y_amavuko)
      errors.itariki_y_amavuko = "Itariki y'amavuko ni ngombwa";
    if (form.indangamuntu && form.indangamuntu.length !== 16)
      errors.indangamuntu = "Indangamuntu igomba kuba imibare 16";
    if (form.telefone && !/^07\d{8}$/.test(form.telefone))
      errors.telefone = "Telefoni ntiyuzuye";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm())
      return showAlertMessage("Uzuza neza amakuru yose", "warning");

    const token = localStorage.getItem("token");
    if (!token) {
      showAlertMessage("Nta token. Banza winjire (Login).", "danger");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        if (key !== 'ifoto' && key !== 'icyemezo_cy_ubukwe') {
          formData.append(key, form[key]);
        }
      });
      if (selectedFile) formData.append('ifoto', selectedFile);
      if (selectedCertFile) formData.append('icyemezo_cy_ubukwe', selectedCertFile);

      if (editingId) {
        await api.put(`${API_URL}/${editingId}`, formData);
        showAlertMessage("Amakuru yavuguruwe neza!", "success");
      } else {
        await api.post(API_URL, formData);
        showAlertMessage("Umuturage yanditswe neza!", "success");
      }
      setShow(false);
      resetForm();
      fetchData();
      if (navigator.vibrate) navigator.vibrate(100);
    } catch (err) {
      showAlertMessage(extractErrorMessage(err, "Habaye ikosa"), "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name])
      setFormErrors((prev) => {
        const n = { ...prev };
        delete n[name];
        return n;
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setForm((prev) => ({ ...prev, ifoto: editingId ? prev.ifoto : "" }));
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next.ifoto;
        return next;
      });
      return;
    }

    if (
      ((!allowedPhotoTypes.has(file.type) && file.type) ||
        !allowedPhotoExtensions.test(file.name || ""))
    ) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto igomba kuba JPG, JPEG cyangwa PNG",
      }));
      e.target.value = "";
      return;
    }

    if (file.size > PHOTO_MAX_SIZE) {
      setSelectedFile(null);
      setFormErrors((prev) => ({
        ...prev,
        ifoto: "Ifoto ntigomba kurenza 2MB",
      }));
      e.target.value = "";
      return;
    }

    setSelectedFile(file);
    setForm((prev) => ({ ...prev, ifoto: file.name }));
    setFormErrors((prev) => {
      const next = { ...prev };
      delete next.ifoto;
      return next;
    });
  };

  // ────────────────────────────────────────────────
  // Fetch & Filter
  // ────────────────────────────────────────────────
  const fetchData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      showAlertMessage("Nta token. Banza winjire (Login).", "warning");
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const url = isUmudugudu
        ? `${getApiBase()}/umudugudu/module-data/abaturage`
        : API_URL;
      const res = await api.get(url);
      const data = res.data;
      if (Array.isArray(data)) {
        setAbaturage(data);
        setFilteredData(data);
        calculateStats(data);
      } else if (data && typeof data === "object") {
        const errorMsg = data.sqlMessage || data.message || data.error || "Seriveri yohereje amakuru atari meza";
        showAlertMessage(safeString(errorMsg), "danger");
        setAbaturage([]);
        setFilteredData([]);
        calculateStats([]);
      } else {
        setAbaturage([]);
        setFilteredData([]);
        calculateStats([]);
      }
    } catch (err) {
      const status = err.response?.status;
      if (status === 401 || status === 403) {
        showAlertMessage("Igihe cyo kwinjira kirangiye. Sohoka maze winjire nanone.", "danger");
      } else {
        showAlertMessage(extractErrorMessage(err, "Habaye ikosa mu kugira amakuru"), "danger");
      }
      setAbaturage([]);
      setFilteredData([]);
      calculateStats([]);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchData();
  }, []);

  // Households (Ingo) for the "which household does this citizen belong
  // to" dropdown — replaces hand-typing a household id.
  const [households, setHouseholds] = useState([]);
  useEffect(() => {
    api.get(`${getApiBase()}/ingo`)
      .then((res) => setHouseholds(Array.isArray(res.data) ? res.data : []))
      .catch(() => setHouseholds([]));
  }, []);

  useEffect(() => {
    if (!Array.isArray(abaturage)) {
      setFilteredData([]);
      return;
    }

    let result = [...abaturage];
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(
        (p) =>
          safeString(p.izina_ribanza).toLowerCase().includes(term) ||
          safeString(p.izina_risoza).toLowerCase().includes(term) ||
          safeString(p.indangamuntu).includes(term) ||
          safeString(p.telefone).includes(term)
      );
    }
    if (filterGender !== "all")
      result = result.filter((p) => p.igitsina === filterGender);
    if (filterUbudehe !== "all")
      result = result.filter(
        (p) => p.icyiciro_cy_imibereho === filterUbudehe
      );
    if (filterStatus !== "all")
      result = result.filter((p) => p.aho_ari === filterStatus);

    setFilteredData(result);
    setCurrentPage(1);
  }, [searchTerm, filterGender, filterUbudehe, filterStatus, abaturage]);

  // Safe array access
  const safeFilteredData = Array.isArray(filteredData) ? filteredData : [];
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = safeFilteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(safeFilteredData.length / itemsPerPage);
  const paginate = (n) => {
    setCurrentPage(n);
    if (topRef.current && isMobile) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Active filter count
  const activeFilterCount = [
    filterGender !== "all",
    filterUbudehe !== "all",
    filterStatus !== "all",
  ].filter(Boolean).length;

  const clearAllFilters = () => {
    setSearchTerm("");
    setFilterGender("all");
    setFilterUbudehe("all");
    setFilterStatus("all");
  };

  // ─── Dynamic Responsive Values ──────────────────────────
  const containerPadding = isExtraSmall
    ? "0.5rem"
    : isSmall
    ? "0.75rem"
    : isMobile
    ? "1rem"
    : "1.5rem";

  const headerFontSize = isExtraSmall
    ? "0.95rem"
    : isSmall
    ? "1.1rem"
    : isMobile
    ? "1.25rem"
    : "1.5rem";

  const statCardPadding = isExtraSmall
    ? "0.75rem"
    : isSmall
    ? "1rem"
    : "1.5rem";

  const statValueSize = isExtraSmall
    ? "1.5rem"
    : isSmall
    ? "1.75rem"
    : isMobile
    ? "2rem"
    : "2.5rem";

  const statTitleSize = isExtraSmall
    ? "0.65rem"
    : isSmall
    ? "0.7rem"
    : "0.85rem";

  const iconRingSize = isSmall ? 50 : isMobile ? 60 : 80;
  const iconInnerSize = isSmall ? 36 : isMobile ? 44 : 60;
  const iconFontSize = isSmall ? "1rem" : isMobile ? "1.25rem" : "1.75rem";

  // ────────────────────────────────────────────────
  // Mobile Card View for Data
  // ────────────────────────────────────────────────
  const renderMobileCard = (person, idx) => {
    if (!person || typeof person !== "object") return null;

    const age = calculateAge(person.itariki_y_amavuko);
    const ubudehe =
      ubudeheCategories.find(
        (c) => c.value === person.icyiciro_cy_imibereho
      ) || {};
    const stat = statusConfig[person.aho_ari] || {};
    const photoUrl = getPhotoUrl(person.ifoto);
    const initials = `${safeString(person.izina_ribanza).charAt(0)}${safeString(
      person.izina_risoza
    ).charAt(0)}`.toUpperCase() || "U";

    return (
      <div
        key={person.umuturage_id || idx}
        style={{
          background: `linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%)`,
          border: `1px solid ${theme.border}`,
          borderRadius: isExtraSmall ? "12px" : "16px",
          padding: isExtraSmall ? "0.75rem" : "1rem",
          marginBottom: "0.75rem",
          transition: "border-color 0.3s ease",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        {/* Top Row: Name + Status */}
        <div
          className="d-flex justify-content-between align-items-start"
          style={{ marginBottom: "0.75rem" }}
        >
          <div className="d-flex gap-2 align-items-start" style={{ flex: 1, minWidth: 0 }}>
            {photoUrl ? (
              <img
                src={photoUrl}
                alt={`${safeString(person.izina_ribanza)} ${safeString(person.izina_risoza)}`}
                onError={handleImgError}
                style={{
                  width: isExtraSmall ? "42px" : "50px",
                  height: isExtraSmall ? "42px" : "50px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: `2px solid ${theme.border}`,
                  flexShrink: 0,
                }}
              />
            ) : (
              <div
                style={{
                  width: isExtraSmall ? "42px" : "50px",
                  height: isExtraSmall ? "42px" : "50px",
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontWeight: 700,
                  flexShrink: 0,
                }}
              >
                {initials}
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: isExtraSmall ? "0.9rem" : "1rem",
                  color: theme.text,
                  marginBottom: "0.25rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {safeString(person.izina_ribanza)} {safeString(person.izina_risoza)}
              </div>
              <div className="d-flex gap-2 flex-wrap">
                <Badge
                  bg={person.igitsina === "Gabo" ? "primary" : "danger"}
                  pill
                  style={{ fontSize: isExtraSmall ? "0.6rem" : "0.7rem" }}
                >
                  {safeString(person.igitsina)}
                </Badge>
                {age !== null && (
                  <Badge
                    bg="info"
                    pill
                    style={{ fontSize: isExtraSmall ? "0.6rem" : "0.7rem" }}
                  >
                    {age} y.
                  </Badge>
                )}
                <Badge
                  bg={stat.color || "secondary"}
                  pill
                  style={{ fontSize: isExtraSmall ? "0.6rem" : "0.7rem" }}
                >
                  {stat.icon && <i className={`bi bi-${stat.icon} me-1`}></i>}
                  {stat.label || safeString(person.aho_ari)}
                </Badge>
              </div>
            </div>
          </div>
          <span
            style={{
              color: "#9ca3af",
              fontSize: "0.75rem",
              flexShrink: 0,
              marginLeft: "0.5rem",
            }}
          >
            #{indexOfFirst + idx + 1}
          </span>
        </div>

        {/* Info Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: isExtraSmall ? "0.35rem" : "0.5rem",
            marginBottom: "0.75rem",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "0.65rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Indangamuntu
            </div>
            <div
              style={{
                fontSize: isExtraSmall ? "0.7rem" : "0.8rem",
                color: theme.text,
                fontFamily: "monospace",
              }}
            >
              {safeString(person.indangamuntu) || "—"}
            </div>
          </div>
          <div>
            <div
              style={{
                fontSize: "0.65rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Telefoni
            </div>
            <div
              style={{
                fontSize: isExtraSmall ? "0.7rem" : "0.8rem",
                color: person.telefone ? "#34d399" : "#6b7280",
              }}
            >
              {person.telefone ? (
                <>
                  <i className="bi bi-telephone-fill me-1"></i>
                  {safeString(person.telefone)}
                </>
              ) : (
                "—"
              )}
            </div>
          </div>
          <div>
            <div
              style={{
                fontSize: "0.65rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Ubudehe
            </div>
            <div>
              {person.icyiciro_cy_imibereho ? (
                <Badge
                  bg={ubudehe.color || "secondary"}
                  pill
                  style={{ fontSize: "0.65rem" }}
                >
                  {safeString(person.icyiciro_cy_imibereho)}
                </Badge>
              ) : (
                <span style={{ color: "#6b7280", fontSize: "0.8rem" }}>—</span>
              )}
            </div>
          </div>
          <div>
            <div
              style={{
                fontSize: "0.65rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Amavuko
            </div>
            <div
              style={{
                fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
                color: theme.text,
              }}
            >
              {formatDateForInput(person.itariki_y_amavuko) || "—"}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div
          className="d-flex gap-2"
          style={{
            borderTop: `1px solid ${theme.border}`,
            paddingTop: "0.75rem",
          }}
        >
          <Button
            variant="outline-info"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
              minHeight: "38px",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
              borderColor: theme.info,
              color: theme.info,
            }}
            onClick={() => handleViewDetails(person)}
          >
            <i className="bi bi-eye me-1"></i>
            {isExtraSmall ? "" : "Reba"}
          </Button>
          <Button
            variant="outline-primary"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
              minHeight: "38px",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
              borderColor: theme.primary,
              color: theme.primary,
            }}
            onClick={() => handleEdit(person)}
          >
            <i className="bi bi-pencil me-1"></i>
            {isExtraSmall ? "" : "Hindura"}
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
              minHeight: "38px",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
              borderColor: "#ef4444",
              color: "#ef4444",
            }}
            onClick={() => openDeleteModal(person.umuturage_id)}
          >
            <i className="bi bi-trash me-1"></i>
            {isExtraSmall ? "" : "Siba"}
          </Button>
        </div>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // Render Pagination (Responsive)
  // ────────────────────────────────────────────────
  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const maxVisible = isSmall ? 3 : isMobile ? 5 : 7;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return (
      <div
        className="d-flex justify-content-between align-items-center flex-wrap"
        style={{
          marginTop: "1rem",
          gap: "0.5rem",
          padding: isSmall ? "0 0.25rem" : "0",
        }}
      >
        <small
          style={{
            color: theme.textMuted,
            fontSize: isSmall ? "0.7rem" : "0.8rem",
          }}
        >
          {indexOfFirst + 1} – {Math.min(indexOfLast, safeFilteredData.length)}{" "}
          kuri {safeFilteredData.length}
        </small>
        <Pagination className="mb-0" size={isSmall ? "sm" : undefined}>
          <Pagination.Prev
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {startPage > 1 && (
            <>
              <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
              {startPage > 2 && <Pagination.Ellipsis disabled />}
            </>
          )}
          {pages.map((p) => (
            <Pagination.Item
              key={p}
              active={p === currentPage}
              onClick={() => paginate(p)}
            >
              {p}
            </Pagination.Item>
          ))}
          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <Pagination.Ellipsis disabled />}
              <Pagination.Item onClick={() => paginate(totalPages)}>
                {totalPages}
              </Pagination.Item>
            </>
          )}
          <Pagination.Next
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // JSX
  // ────────────────────────────────────────────────
  return (
    <div
      ref={topRef}
      style={{
        backgroundColor: theme.bg,
        color: theme.text,
        minHeight: "100vh",
        padding: containerPadding,
        paddingTop: isMobile
          ? `max(${containerPadding}, env(safe-area-inset-top, 0px))`
          : containerPadding,
        paddingBottom: isMobile
          ? `max(${containerPadding}, env(safe-area-inset-bottom, 0px))`
          : containerPadding,
        WebkitOverflowScrolling: "touch",
        overflowX: "hidden",
      }}
    >
      {/* ═══════════ RESPONSIVE GLOBAL STYLES ═══════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800&display=swap');
        
        * {
          font-family: 'Nunito Sans', system-ui, -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          -webkit-text-size-adjust: 100%;
          -moz-text-size-adjust: 100%;
          text-size-adjust: 100%;
        }

        html, body {
          
        }

        .stat-card {
          background: linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%) !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isSmall ? "14px" : "20px"} !important;
          transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
          box-shadow: 0 1px 4px rgba(11,61,145,0.06) !important;
          overflow: hidden;
        }

        @media (hover: hover) and (min-width: 769px) {
          .stat-card:hover {
            transform: translateY(-8px) scale(1.02) !important;
            box-shadow: 0 20px 40px -12px rgba(11, 61, 145, 0.18) !important;
            border-color: ${theme.primary} !important;
          }
        }

        @media (hover: none) {
          .stat-card:active {
            transform: scale(0.98) !important;
            border-color: ${theme.primary} !important;
          }
          .stat-card:hover {
            transform: none !important;
          }
        }

        .modern-table-wrapper {
          background: ${theme.cardBg};
          border: 1px solid ${theme.border};
          border-radius: ${isSmall ? "12px" : "20px"};
          overflow: hidden;
          box-shadow: 0 0 0 1px rgba(11,61,145,0.05), 0 12px 32px -12px rgba(11,61,145,0.15);
          position: relative;
        }

        .modern-table-wrapper::after {
          content: '';
          display: block;
          height: 3px;
          background: linear-gradient(90deg, ${theme.primary} 0%, ${theme.primaryDark} 50%, transparent 100%);
          border-radius: 0 0 ${isSmall ? "12px" : "20px"} ${isSmall ? "12px" : "20px"};
        }

        .modern-table {
          background-color: ${theme.cardBg} !important;
          color: ${theme.text} !important;
          margin-bottom: 0 !important;
          min-width: ${isSmall ? "960px" : isTablet ? "1100px" : "1060px"};
          border-collapse: separate !important;
          border-spacing: 0 !important;
          table-layout: auto !important;
        }

        .modern-table thead {
          background: linear-gradient(180deg, ${theme.primary} 0%, ${theme.primaryDark} 100%) !important;
        }

        .modern-table thead th {
          background: transparent !important;
          color: rgba(255,255,255,0.85) !important;
          font-weight: 700 !important;
          font-size: ${isSmall ? "0.65rem" : isTablet ? "0.7rem" : "0.72rem"} !important;
          text-transform: uppercase !important;
          letter-spacing: ${isSmall ? "0.4px" : "0.8px"} !important;
          padding: ${isSmall ? "0.85rem 0.75rem" : isTablet ? "1rem 0.875rem" : "1rem 1rem"} !important;
          border-bottom: 2px solid rgba(255,255,255,0.12) !important;
          border-top: none !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          position: relative;
          vertical-align: middle !important;
        }

        .modern-table thead th::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, rgba(250,210,1,0.6) 0%, transparent 100%);
          pointer-events: none;
        }

        .modern-table tbody tr {
          transition: background 0.2s ease !important;
          border-bottom: 1px solid ${theme.border} !important;
        }

        .modern-table tbody tr:nth-child(even) {
          background: rgba(11,61,145,0.02) !important;
        }

        @media (hover: hover) {
          .modern-table tbody tr:hover {
            background: ${theme.tableRowHover} !important;
          }
          .modern-table tbody tr:hover td:first-child {
            border-left: 3px solid ${theme.primary} !important;
          }
        }

        .modern-table tbody td {
          background: transparent !important;
          color: ${theme.text} !important;
          padding: ${isSmall ? "0.75rem 0.75rem" : isTablet ? "0.875rem 0.875rem" : "0.875rem 1rem"} !important;
          vertical-align: middle !important;
          border: none !important;
          border-left: 3px solid transparent !important;
          font-size: ${isSmall ? "0.78rem" : isTablet ? "0.82rem" : "0.88rem"} !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          max-width: 0 !important;
          transition: border-color 0.2s ease !important;
        }

        .modern-table tbody td.td-nowrap {
          max-width: none !important;
          overflow: visible !important;
        }

        .modern-table tbody td:not(:first-child) {
          border-left: none !important;
        }

        .modern-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        .table-scroll-wrapper {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-x: contain;
          padding-bottom: ${isMobile ? "0.2rem" : "0.35rem"};
          scrollbar-gutter: stable both-edges;
        }

        .table-scroll-wrapper::-webkit-scrollbar {
          height: ${isMobile ? "0" : "6px"};
        }

        .table-scroll-wrapper::-webkit-scrollbar-track {
          background: transparent;
        }

        .table-scroll-wrapper::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 10px;
        }

        .badge {
          font-weight: 600 !important;
          padding: ${isSmall ? "0.3rem 0.55rem" : "0.35rem 0.7rem"} !important;
          font-size: ${isSmall ? "0.65rem" : "0.72rem"} !important;
          border-radius: 8px !important;
          letter-spacing: 0.2px !important;
          white-space: nowrap !important;
          display: inline-flex !important;
          align-items: center !important;
          line-height: 1.2 !important;
        }
        .badge.bg-warning { color: #1a1200 !important; }
        .badge.bg-secondary { color: #f0f0f5 !important; }
        .badge.bg-success { color: #fff !important; }
        .badge.bg-danger { color: #fff !important; }
        .badge.bg-info { color: #0a1a1f !important; }
        .badge.bg-primary { color: #fff !important; }

        .btn-action {
          width: ${isMobile ? "40px" : "42px"} !important;
          height: ${isMobile ? "40px" : "42px"} !important;
          padding: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 12px !important;
          transition: all 0.3s ease !important;
          border: 1px solid transparent !important;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
          flex-shrink: 0;
        }

        @media (hover: hover) {
          .btn-action:hover {
            transform: scale(1.1) !important;
          }
        }

        .btn-action.btn-outline-info {
          border-color: ${theme.info} !important;
          color: ${theme.info} !important;
        }
        .btn-action.btn-outline-info:hover {
          background: rgba(3, 105, 161, 0.1) !important;
        }
        .btn-action.btn-outline-primary {
          border-color: ${theme.primary} !important;
          color: ${theme.primary} !important;
        }
        .btn-action.btn-outline-primary:hover {
          background: rgba(11, 61, 145, 0.1) !important;
        }
        .btn-action.btn-outline-danger {
          border-color: #ef4444 !important;
          color: #ef4444 !important;
        }
        .btn-action.btn-outline-danger:hover {
          background: rgba(239, 68, 68, 0.15) !important;
        }

        .ibikorwa-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 4px !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          border: none !important;
          font-size: 0.75rem !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          white-space: nowrap !important;
          line-height: 1.2 !important;
          flex-direction: row !important;
          flex-shrink: 0 !important;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
          min-height: 30px !important;
        }
        .ibikorwa-btn i {
          font-size: 0.82rem !important;
          flex-shrink: 0 !important;
          display: inline-block !important;
        }
        .ibikorwa-btn span {
          display: inline !important;
          white-space: nowrap !important;
        }
        .ibikorwa-view {
          background: rgba(3, 105, 161, 0.1);
          color: ${theme.info};
          border: 1px solid rgba(3, 105, 161, 0.3) !important;
        }
        .ibikorwa-view:hover {
          background: rgba(3, 105, 161, 0.18);
          color: ${theme.info};
          transform: translateY(-1px);
        }
        .ibikorwa-edit {
          background: rgba(11, 61, 145, 0.1);
          color: ${theme.primary};
          border: 1px solid rgba(11, 61, 145, 0.3) !important;
        }
        .ibikorwa-edit:hover {
          background: rgba(11, 61, 145, 0.18);
          color: ${theme.primaryDark};
          transform: translateY(-1px);
        }
        .ibikorwa-delete {
          background: rgba(220, 38, 38, 0.1);
          color: ${theme.danger};
          border: 1px solid rgba(220, 38, 38, 0.3) !important;
        }
        .ibikorwa-delete:hover {
          background: rgba(220, 38, 38, 0.18);
          color: #b91c1c;
          transform: translateY(-1px);
        }
        @media (hover: none) {
          .ibikorwa-btn:active { opacity: 0.75; transform: scale(0.96); }
        }

        .filter-card {
          background: linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%) !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isSmall ? "12px" : "16px"} !important;
        }

        .search-input {
          background: ${theme.cardBg} !important;
          border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important;
          border-radius: 12px !important;
          transition: all 0.3s ease !important;
          font-size: 16px !important;
          min-height: ${isMobile ? "44px" : "auto"};
        }
        .search-input:focus {
          border-color: ${theme.primary} !important;
          box-shadow: 0 0 0 3px rgba(11, 61, 145, 0.15) !important;
        }
        .search-input::placeholder {
          color: #94a3b8 !important;
        }

        .pagination .page-link {
          background: ${theme.cardBg} !important;
          border-color: ${theme.border} !important;
          color: ${theme.textMuted} !important;
          border-radius: ${isSmall ? "8px" : "10px"} !important;
          margin: 0 ${isSmall ? "1px" : "3px"} !important;
          transition: all 0.3s ease !important;
          min-width: ${isMobile ? "36px" : "auto"};
          min-height: ${isMobile ? "36px" : "auto"};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: ${isSmall ? "0.75rem" : "0.85rem"};
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        .pagination .page-link:hover {
          background: ${theme.cardBgHover} !important;
          border-color: ${theme.primary} !important;
          color: ${theme.primary} !important;
        }
        .pagination .page-item.active .page-link {
          background: linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%) !important;
          border-color: ${theme.primary} !important;
          color: #ffffff !important;
        }

        .modal-content {
          background: ${theme.cardBg} !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isMobile ? "16px" : "24px"} !important;
          color: ${theme.text} !important;
          margin: ${isMobile ? "0.5rem" : "auto"};
          max-height: ${isMobile ? "90vh" : "auto"};
        }
        .modal-header {
          border-bottom: 1px solid ${theme.border} !important;
          padding: ${isSmall ? "0.75rem 1rem" : "1rem 1.5rem"} !important;
        }
        .modal-body {
          padding: ${isSmall ? "0.75rem" : isMobile ? "1rem" : "1.5rem"} !important;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          max-height: ${isMobile ? "60vh" : "auto"};
        }
        .modal-footer {
          border-top: 1px solid ${theme.border} !important;
          padding: ${isSmall ? "0.5rem 0.75rem" : "0.75rem 1.5rem"} !important;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .modal-footer .btn {
          min-height: ${isMobile ? "46px" : "42px"};
          flex: 1 1 ${isMobile ? "100%" : "160px"};
        }
        .modal-title {
          font-size: ${isSmall ? "0.95rem" : isMobile ? "1.05rem" : "1.25rem"} !important;
        }

        .form-control, .form-select {
          background: ${theme.cardBg} !important;
          border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important;
          border-radius: 12px !important;
          padding: ${isSmall ? "0.6rem 0.75rem" : "0.75rem 1rem"} !important;
          font-size: 16px !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-appearance: none;
          appearance: none;
        }
        .form-control[type="file"] {
          padding-top: ${isSmall ? "0.5rem" : "0.65rem"} !important;
          padding-bottom: ${isSmall ? "0.5rem" : "0.65rem"} !important;
          line-height: 1.4 !important;
        }
        .form-control[type="file"]::file-selector-button {
          margin-right: 0.75rem;
          border: 0;
          border-radius: 10px;
          padding: 0.5rem 0.9rem;
          font: inherit;
          font-weight: 600;
          background: ${theme.primary};
          color: #ffffff;
          cursor: pointer;
        }
        .form-control:focus, .form-select:focus {
          border-color: ${theme.primary} !important;
          box-shadow: 0 0 0 3px rgba(11, 61, 145, 0.15) !important;
          background: ${theme.cardBg} !important;
          color: ${theme.text} !important;
        }
        .form-label {
          color: ${theme.textMuted} !important;
          font-weight: 500 !important;
          margin-bottom: 0.5rem !important;
          font-size: ${isSmall ? "0.8rem" : "0.9rem"} !important;
        }

        .icon-ring {
          width: ${iconRingSize}px;
          height: ${iconRingSize}px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin: 0 auto;
        }
        .icon-ring::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          padding: ${isSmall ? "2px" : "3px"};
          background: linear-gradient(135deg, var(--ring-color) 0%, transparent 60%);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
        }
        .icon-ring-inner {
          width: ${iconInnerSize}px;
          height: ${iconInnerSize}px;
          border-radius: 50%;
          background: linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dropdown-menu {
          background: ${theme.cardBg} !important;
          border: 1px solid ${theme.border} !important;
          border-radius: 12px !important;
          padding: 0.5rem !important;
          min-width: ${isMobile ? "180px" : "auto"};
          box-shadow: 0 12px 32px -8px rgba(11,61,145,0.2) !important;
        }
        .dropdown-item {
          color: ${theme.textMuted} !important;
          border-radius: 8px !important;
          padding: ${isMobile ? "0.7rem 1rem" : "0.6rem 1rem"} !important;
          transition: all 0.2s ease !important;
          font-size: ${isSmall ? "0.85rem" : "0.9rem"} !important;
          -webkit-tap-highlight-color: transparent;
        }
        .dropdown-item:hover, .dropdown-item:active {
          background: rgba(11, 61, 145, 0.08) !important;
          color: ${theme.primary} !important;
        }

        .btn-primary-modern {
          background: linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%) !important;
          border: none !important;
          border-radius: ${isSmall ? "10px" : "14px"} !important;
          padding: ${isSmall ? "0.65rem 1rem" : "0.85rem 1.75rem"} !important;
          font-weight: 600 !important;
          font-size: ${isSmall ? "0.8rem" : "0.9rem"} !important;
          transition: all 0.3s ease !important;
          box-shadow: 0 4px 15px rgba(11, 61, 145, 0.25) !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        @media (hover: hover) {
          .btn-primary-modern:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 8px 22px rgba(11, 61, 145, 0.32) !important;
          }
        }

        .alert {
          border-radius: ${isSmall ? "10px" : "14px"} !important;
          border: none !important;
          font-size: ${isSmall ? "0.8rem" : "0.9rem"} !important;
          padding: ${isSmall ? "0.5rem 0.75rem" : "0.75rem 1.25rem"} !important;
        }

        .empty-state {
          background: linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%);
          border: 1px dashed ${theme.border};
          border-radius: ${isSmall ? "14px" : "20px"};
        }

        .mobile-filter-panel {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: ${theme.cardBg};
          border-top: 1px solid ${theme.border};
          border-radius: 20px 20px 0 0;
          padding: 1.5rem;
          padding-bottom: max(1.5rem, env(safe-area-inset-bottom, 0px));
          z-index: 1060;
          transform: translateY(${showMobileFilters ? "0" : "100%"});
          transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          box-shadow: 0 -10px 40px rgba(0,0,0,0.5);
          max-height: 70vh;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }

        .mobile-filter-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          z-index: 1055;
          opacity: ${showMobileFilters ? 1 : 0};
          pointer-events: ${showMobileFilters ? "auto" : "none"};
          transition: opacity 0.3s ease;
        }

        @supports (padding: max(0px)) {
          .safe-pad {
            padding-left: max(0px, env(safe-area-inset-left));
            padding-right: max(0px, env(safe-area-inset-right));
          }
        }

        @media (hover: none) {
          button:active, .btn:active, .dropdown-toggle:active {
            opacity: 0.8 !important;
            transform: scale(0.97) !important;
          }
          .card:hover {
            transform: none !important;
            box-shadow: none !important;
          }
        }

        @media (max-width: 280px) {
          .card-body { padding: 0.4rem !important; }
          .btn { font-size: 0.7rem !important; padding: 0.25rem 0.4rem !important; }
          .badge { font-size: 0.55rem !important; padding: 0.25rem 0.4rem !important; }
        }

        @media (max-height: 500px) and (orientation: landscape) {
          .stat-card .card-body { padding: 0.5rem !important; }
          .icon-ring { display: none !important; }
        }

        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            transition-duration: 0.01ms !important;
          }
        }

        @media print {
          body { background: white !important; color: black !important; }
          .btn, .filter-card, .stat-card, .mobile-filter-panel { display: none !important; }
          .modern-table, .modern-table th, .modern-table td {
            color: black !important;
            background: white !important;
            border: 1px solid #ccc !important;
          }
        }

        @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
          .shadow, .shadow-lg {
            box-shadow: 0 2px 10px rgba(0,0,0,0.15) !important;
          }
        }

        ::-webkit-scrollbar { width: ${isMobile ? "0" : "6px"}; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }

        .dropdown-toggle {
          min-height: ${isMobile ? "40px" : "auto"} !important;
          font-size: ${isSmall ? "0.75rem" : "0.85rem"} !important;
          border-radius: 10px !important;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
      `}</style>

      {/* ═══════════ HEADER ═══════════ */}
      <div
        className="d-flex justify-content-between align-items-start flex-wrap"
        style={{ marginBottom: isMobile ? "1rem" : "1.5rem", gap: "0.5rem" }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2
            className="fw-bold mb-1"
            style={{
              color: theme.primary,
              fontSize: headerFontSize,
              lineHeight: 1.3,
            }}
          >
            <i className="bi bi-people-fill me-2"></i>
            Abaturage
          </h2>
          {!isShortScreen && (
            <small
              style={{
                color: theme.textMuted,
                fontSize: isSmall ? "0.7rem" : "0.8rem",
                display: "block",
              }}
            >
              {isSmall
                ? "Gukurikirana abaturage"
                : "Kwandika, gusuzuma no gukurikirana abaturage"}
            </small>
          )}
        </div>

        <div className="d-flex gap-2 flex-wrap" style={{ flexShrink: 0 }}>
          <Button
            className="btn-primary-modern shadow"
            onClick={() => {
              resetForm();
              setShow(true);
            }}
            style={{
              fontSize: isSmall ? "0.75rem" : "0.85rem",
              padding: isSmall ? "0.5rem 0.75rem" : "0.65rem 1.25rem",
            }}
          >
            <i className="bi bi-person-plus-fill me-1"></i>
            {isExtraSmall ? "+" : isSmall ? "Andika" : "Andika Umuturage"}
          </Button>
          <Button
            variant="outline-light"
            onClick={fetchData}
            style={{
              borderRadius: "12px",
              borderColor: theme.border,
              minWidth: isMobile ? "40px" : "auto",
              minHeight: isMobile ? "40px" : "auto",
              padding: isSmall ? "0.4rem" : "0.5rem 0.75rem",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
          >
            <i className="bi bi-arrow-clockwise"></i>
          </Button>
          <Button
            variant="outline-success"
            onClick={exportToCSV}
            style={{
              borderRadius: "12px",
              minWidth: isMobile ? "40px" : "auto",
              minHeight: isMobile ? "40px" : "auto",
              padding: isSmall ? "0.4rem" : "0.5rem 0.75rem",
              fontSize: isSmall ? "0.75rem" : "0.85rem",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
          >
            <i className="bi bi-download"></i>
            {!isSmall && <span className="ms-1">Excel</span>}
          </Button>
        </div>
      </div>

      {/* ═══════════ ALERT ═══════════ */}
      {alert.show && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({ show: false, message: "", variant: "" })}
          className="mb-3 shadow"
          style={{
            position: isMobile ? "fixed" : "relative",
            top: isMobile
              ? "max(0.5rem, env(safe-area-inset-top, 0px))"
              : "auto",
            left: isMobile ? "0.5rem" : "auto",
            right: isMobile ? "0.5rem" : "auto",
            zIndex: isMobile ? 1100 : "auto",
            margin: isMobile ? 0 : undefined,
          }}
        >
          {safeString(alert.message)}
        </Alert>
      )}

      {/* ═══════════ STATS ═══════════ */}
      <Row
        className="mb-3 mb-md-4"
        style={{ gap: 0, rowGap: isSmall ? "0.5rem" : "1rem" }}
      >
        {[
          {
            title: isSmall ? "Bose" : "Abaturage Bose",
            value: stats.total,
            color: theme.primary,
            icon: "people-fill",
            sub: `${stats.male}G • ${stats.female}F`,
          },
          {
            title: "Bariho",
            value: stats.present,
            color: theme.success,
            icon: "house-check-fill",
            percent: stats.total
              ? Math.round((stats.present / stats.total) * 100)
              : 0,
          },
          {
            title: "Bimukiye",
            value: stats.moved,
            color: theme.warning,
            icon: "box-arrow-right",
          },
          {
            title: isSmall ? "Bapfuye" : "Bitabye Imana",
            value: stats.deceased,
            color: "#71717a",
            icon: "heart-fill",
          },
        ].map((item, i) => (
          <Col key={i} xs={6} sm={6} lg={3} className="mb-2 mb-lg-0">
            <Card className="stat-card border-0 h-100">
              <Card.Body
                className="text-center"
                style={{ padding: statCardPadding }}
              >
                {!(isShortScreen && isLandscape) && (
                  <div
                    className="icon-ring mb-2"
                    style={{ "--ring-color": item.color }}
                  >
                    <div className="icon-ring-inner">
                      <i
                        className={`bi bi-${item.icon}`}
                        style={{ fontSize: iconFontSize, color: item.color }}
                      ></i>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    fontSize: statValueSize,
                    fontWeight: 800,
                    color: theme.text,
                    lineHeight: 1.2,
                  }}
                >
                  {(typeof item.value === "number" ? item.value : 0).toLocaleString()}
                </div>
                <div
                  style={{
                    fontSize: statTitleSize,
                    fontWeight: 500,
                    color: theme.textMuted,
                    textTransform: "uppercase",
                    letterSpacing: "0.3px",
                    marginTop: "0.25rem",
                  }}
                >
                  {item.title}
                </div>
                {item.sub && !isExtraSmall && (
                  <div
                    style={{
                      fontSize: "0.7rem",
                      color: "#9ca3af",
                      marginTop: "0.25rem",
                    }}
                  >
                    {item.sub}
                  </div>
                )}
                {item.percent !== undefined && (
                  <Badge
                    className="mt-1"
                    style={{
                      background: `${item.color}20`,
                      color: item.color,
                      fontSize: isSmall ? "0.65rem" : "0.75rem",
                    }}
                  >
                    {item.percent}%
                  </Badge>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* ═══════════ FILTERS ═══════════ */}
      <Card className="filter-card border-0 shadow mb-3 mb-md-4">
        <Card.Body
          style={{
            padding: isSmall ? "0.75rem" : isMobile ? "1rem" : "1.25rem",
          }}
        >
          {isMobile ? (
            <div>
              <div className="d-flex gap-2">
                <InputGroup style={{ flex: 1 }}>
                  <InputGroup.Text
                    style={{
                      background: theme.cardBgHover,
                      borderColor: theme.border,
                      color: theme.textMuted,
                      borderRadius: "12px 0 0 12px",
                      padding: "0.5rem",
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Shakisha..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                    style={{ borderRadius: "0 12px 12px 0" }}
                  />
                </InputGroup>
                <Button
                  variant="outline-light"
                  onClick={() => setShowMobileFilters(true)}
                  style={{
                    borderRadius: "12px",
                    borderColor:
                      activeFilterCount > 0 ? theme.primary : theme.border,
                    color:
                      activeFilterCount > 0 ? theme.primary : theme.textMuted,
                    minWidth: "44px",
                    minHeight: "44px",
                    position: "relative",
                    WebkitTapHighlightColor: "transparent",
                    touchAction: "manipulation",
                  }}
                >
                  <i className="bi bi-sliders"></i>
                  {activeFilterCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-4px",
                        right: "-4px",
                        background: theme.danger,
                        color: "#fff",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        fontSize: "0.65rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                      }}
                    >
                      {activeFilterCount}
                    </span>
                  )}
                </Button>
                {!isExtraSmall && (
                  <Button
                    variant="outline-light"
                    onClick={() => setMobileCardView(!mobileCardView)}
                    style={{
                      borderRadius: "12px",
                      borderColor: theme.border,
                      minWidth: "44px",
                      minHeight: "44px",
                      WebkitTapHighlightColor: "transparent",
                      touchAction: "manipulation",
                    }}
                  >
                    <i
                      className={`bi bi-${
                        mobileCardView ? "table" : "grid-3x3-gap"
                      }`}
                    ></i>
                  </Button>
                )}
              </div>

              {activeFilterCount > 0 && (
                <div
                  className="d-flex gap-1 flex-wrap mt-2"
                  style={{ paddingTop: "0.25rem" }}
                >
                  {filterGender !== "all" && (
                    <Badge
                      bg="primary"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.65rem" }}
                      onClick={() => setFilterGender("all")}
                    >
                      {filterGender} ✕
                    </Badge>
                  )}
                  {filterUbudehe !== "all" && (
                    <Badge
                      bg="warning"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.65rem" }}
                      onClick={() => setFilterUbudehe("all")}
                    >
                      {filterUbudehe} ✕
                    </Badge>
                  )}
                  {filterStatus !== "all" && (
                    <Badge
                      bg="success"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.65rem" }}
                      onClick={() => setFilterStatus("all")}
                    >
                      {statusConfig[filterStatus]?.label || filterStatus} ✕
                    </Badge>
                  )}
                  <Badge
                    bg="secondary"
                    pill
                    style={{ cursor: "pointer", fontSize: "0.65rem" }}
                    onClick={clearAllFilters}
                  >
                    Siba byose ✕
                  </Badge>
                </div>
              )}
            </div>
          ) : (
            <Row className="g-3">
              <Col md={5}>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      background: theme.cardBgHover,
                      borderColor: theme.border,
                      color: theme.textMuted,
                      borderRadius: "12px 0 0 12px",
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Shakisha amazina, indangamuntu, telefoni..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                    style={{ borderRadius: "0 12px 12px 0" }}
                  />
                </InputGroup>
              </Col>
              <Col md={7}>
                <div className="d-flex gap-2 flex-wrap">
                  <DropdownButton
                    variant="outline-light"
                    title={
                      <>
                        <i className="bi bi-gender-ambiguous me-1"></i>
                        Igitsina
                      </>
                    }
                  >
                    <Dropdown.Item onClick={() => setFilterGender("all")}>
                      Byose
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setFilterGender("Gabo")}>
                      Gabo
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setFilterGender("Gore")}>
                      Gore
                    </Dropdown.Item>
                  </DropdownButton>
                  <DropdownButton
                    variant="outline-light"
                    title={
                      <>
                        <i className="bi bi-funnel me-1"></i>Ubudehe
                      </>
                    }
                  >
                    <Dropdown.Item onClick={() => setFilterUbudehe("all")}>
                      Byose
                    </Dropdown.Item>
                    {ubudeheCategories.map((c) => (
                      <Dropdown.Item
                        key={c.value}
                        onClick={() => setFilterUbudehe(c.value)}
                      >
                        <i
                          className={`bi bi-${c.icon} me-2 text-${c.color}`}
                        ></i>
                        {c.label}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                  <DropdownButton
                    variant="outline-light"
                    title={
                      <>
                        <i className="bi bi-geo-alt me-1"></i>Aho Ari
                      </>
                    }
                  >
                    <Dropdown.Item onClick={() => setFilterStatus("all")}>
                      Byose
                    </Dropdown.Item>
                    {Object.entries(statusConfig).map(([k, v]) => (
                      <Dropdown.Item
                        key={k}
                        onClick={() => setFilterStatus(k)}
                      >
                        <i
                          className={`bi bi-${v.icon} me-2 text-${v.color}`}
                        ></i>
                        {v.label}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                  {activeFilterCount > 0 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={clearAllFilters}
                      style={{ borderRadius: "10px" }}
                    >
                      <i className="bi bi-x-lg me-1"></i>Siba Byose
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* ═══════════ MOBILE FILTER PANEL ═══════════ */}
      {isMobile && (
        <>
          <div
            className="mobile-filter-overlay"
            onClick={() => setShowMobileFilters(false)}
          />
          <div className="mobile-filter-panel">
            <div
              style={{
                width: "40px",
                height: "4px",
                background: "#cbd5e1",
                borderRadius: "2px",
                margin: "0 auto 1.25rem",
              }}
            />
            <h6
              style={{
                color: theme.text,
                fontWeight: 700,
                marginBottom: "1rem",
                fontSize: "1rem",
              }}
            >
              <i className="bi bi-sliders me-2"></i>Amahitamo
            </h6>

            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  display: "block",
                }}
              >
                Igitsina
              </label>
              <div className="d-flex gap-2">
                {[
                  { val: "all", label: "Byose" },
                  { val: "Gabo", label: "Gabo" },
                  { val: "Gore", label: "Gore" },
                ].map((opt) => (
                  <Button
                    key={opt.val}
                    variant={
                      filterGender === opt.val ? "primary" : "outline-light"
                    }
                    size="sm"
                    onClick={() => setFilterGender(opt.val)}
                    style={{
                      borderRadius: "10px",
                      flex: 1,
                      minHeight: "40px",
                      borderColor:
                        filterGender === opt.val
                          ? theme.primary
                          : theme.border,
                      WebkitTapHighlightColor: "transparent",
                    }}
                  >
                    {opt.label}
                  </Button>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  display: "block",
                }}
              >
                Ubudehe
              </label>
              <div className="d-flex gap-2 flex-wrap">
                <Button
                  variant={
                    filterUbudehe === "all" ? "primary" : "outline-light"
                  }
                  size="sm"
                  onClick={() => setFilterUbudehe("all")}
                  style={{
                    borderRadius: "10px",
                    minHeight: "40px",
                    borderColor:
                      filterUbudehe === "all" ? theme.primary : theme.border,
                    WebkitTapHighlightColor: "transparent",
                  }}
                >
                  Byose
                </Button>
                {ubudeheCategories.map((c) => (
                  <Button
                    key={c.value}
                    variant={
                      filterUbudehe === c.value ? c.color : "outline-light"
                    }
                    size="sm"
                    onClick={() => setFilterUbudehe(c.value)}
                    style={{
                      borderRadius: "10px",
                      minHeight: "40px",
                      borderColor:
                        filterUbudehe === c.value ? undefined : theme.border,
                      WebkitTapHighlightColor: "transparent",
                    }}
                  >
                    {c.label}
                  </Button>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  display: "block",
                }}
              >
                Aho Ari
              </label>
              <div className="d-flex gap-2 flex-wrap">
                <Button
                  variant={
                    filterStatus === "all" ? "primary" : "outline-light"
                  }
                  size="sm"
                  onClick={() => setFilterStatus("all")}
                  style={{
                    borderRadius: "10px",
                    minHeight: "40px",
                    borderColor:
                      filterStatus === "all" ? theme.primary : theme.border,
                    WebkitTapHighlightColor: "transparent",
                  }}
                >
                  Byose
                </Button>
                {Object.entries(statusConfig).map(([k, v]) => (
                  <Button
                    key={k}
                    variant={filterStatus === k ? v.color : "outline-light"}
                    size="sm"
                    onClick={() => setFilterStatus(k)}
                    style={{
                      borderRadius: "10px",
                      minHeight: "40px",
                      borderColor:
                        filterStatus === k ? undefined : theme.border,
                      fontSize: "0.75rem",
                      WebkitTapHighlightColor: "transparent",
                    }}
                  >
                    {v.label}
                  </Button>
                ))}
              </div>
            </div>

            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                className="flex-fill"
                onClick={clearAllFilters}
                style={{
                  borderRadius: "12px",
                  minHeight: "44px",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                <i className="bi bi-x-lg me-1"></i>Siba Byose
              </Button>
              <Button
                variant="primary"
                className="flex-fill"
                onClick={() => setShowMobileFilters(false)}
                style={{
                  borderRadius: "12px",
                  minHeight: "44px",
                  background: theme.primary,
                  border: "none",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                <i className="bi bi-check-lg me-1"></i>Emeza
              </Button>
            </div>
          </div>
        </>
      )}

      {/* ═══════════ DATA DISPLAY ═══════════ */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner
            animation="border"
            style={{
              color: theme.primary,
              width: isSmall ? "2.5rem" : "3.5rem",
              height: isSmall ? "2.5rem" : "3.5rem",
            }}
          />
          <p
            className="mt-3"
            style={{
              color: theme.textMuted,
              fontSize: isSmall ? "0.8rem" : "0.9rem",
            }}
          >
            Gutegura amakuru...
          </p>
        </div>
      ) : currentItems.length === 0 ? (
        <div
          className="empty-state text-center"
          style={{ padding: isSmall ? "2rem 1rem" : "3rem" }}
        >
          <i
            className="bi bi-inbox-fill"
            style={{
              fontSize: isSmall ? "3rem" : "5rem",
              color: "#2a2a2a",
            }}
          ></i>
          <h4
            className="mt-3"
            style={{
              color: theme.textMuted,
              fontSize: isSmall ? "1rem" : "1.2rem",
            }}
          >
            Nta makuru ahari
          </h4>
          <p
            style={{
              color: "#9ca3af",
              fontSize: isSmall ? "0.75rem" : "0.85rem",
            }}
          >
            {searchTerm || activeFilterCount > 0
              ? "Hindura amahitamo kugira ubone ibisubizo"
              : "Tangira wandike umuturage mushya"}
          </p>
          {(searchTerm || activeFilterCount > 0) && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={clearAllFilters}
              style={{ borderRadius: "10px", marginTop: "0.5rem" }}
            >
              <i className="bi bi-x-lg me-1"></i>Siba amahitamo yose
            </Button>
          )}
        </div>
      ) : (
        <>
          {isMobile && mobileCardView ? (
            <div>
              <div
                style={{
                  fontSize: "0.7rem",
                  color: theme.textMuted,
                  marginBottom: "0.5rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  fontWeight: 600,
                }}
              >
                {safeFilteredData.length} abaturage
              </div>
              {currentItems.map((person, idx) =>
                renderMobileCard(person, idx)
              )}
            </div>
          ) : (
            <div className="modern-table-wrapper">
              <div
                style={{
                  padding: isSmall ? "0.6rem 0.75rem" : "0.75rem 1.25rem",
                  borderBottom: `1px solid ${theme.border}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: `linear-gradient(90deg, ${theme.primaryDark} 0%, ${theme.primary} 100%)`,
                }}
              >
                <span style={{ color: "rgba(255,255,255,0.85)", fontSize: isSmall ? "0.72rem" : "0.8rem", fontWeight: 600, letterSpacing: "0.5px" }}>
                  <i className="bi bi-table me-2" style={{ color: "#FAD201" }}></i>
                  Urutonde rw'Abantu
                </span>
                <span
                  style={{
                    background: "rgba(250,210,1,0.18)",
                    color: "#FAD201",
                    borderRadius: "20px",
                    padding: "0.2rem 0.75rem",
                    fontSize: "0.72rem",
                    fontWeight: 700,
                    border: "1px solid rgba(250,210,1,0.35)",
                  }}
                >
                  {safeFilteredData.length} banditse
                </span>
              </div>
              <div className="table-scroll-wrapper" ref={tableWrapperRef}>
                <Table hover className="modern-table">
                  <thead>
                    <tr>
                      <th className="text-center" style={{ minWidth: "44px", width: "44px" }}>#</th>
                      <th className="text-center" style={{ minWidth: "72px", width: "72px" }}>
                        <i className="bi bi-image me-1" style={{ opacity: 0.6 }}></i>Ifoto
                      </th>
                      <th style={{ minWidth: "150px" }}>
                        <i className="bi bi-person me-1" style={{ opacity: 0.6 }}></i>Amazina
                      </th>
                      <th className="text-center" style={{ minWidth: "72px" }}>
                        <i className="bi bi-gender-ambiguous me-1" style={{ opacity: 0.6 }}></i>Igitsina
                      </th>
                      <th className="text-center" style={{ minWidth: "60px" }}>
                        <i className="bi bi-clock me-1" style={{ opacity: 0.6 }}></i>Imyaka
                      </th>
                      {!isSmall && (
                        <th style={{ minWidth: "170px" }}>
                          <i className="bi bi-credit-card me-1" style={{ opacity: 0.6 }}></i>NIDA
                        </th>
                      )}
                      {!isSmall && (
                        <th style={{ minWidth: "130px" }}>
                          <i className="bi bi-telephone me-1" style={{ opacity: 0.6 }}></i>Telefone
                        </th>
                      )}
                      <th className="text-center" style={{ minWidth: "90px" }}>
                        <i className="bi bi-geo-alt me-1" style={{ opacity: 0.6 }}></i>Aho Ari
                      </th>
                      <th className="text-center" style={{ minWidth: "100px" }}>
                        <i className="bi bi-heart me-1" style={{ opacity: 0.6 }}></i>Ubukwe
                      </th>
                      <th className="text-center" style={{ minWidth: "100px" }}>
                        <i className="bi bi-file-earmark-text me-1" style={{ opacity: 0.6 }}></i>Icyemezo
                      </th>
                      <th className="text-center" style={{ minWidth: "170px", width: "170px" }}>
                        <i className="bi bi-lightning me-1" style={{ opacity: 0.6 }}></i>Ibikorwa
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((person, idx) => {
                      if (!person || typeof person !== "object") return null;
                      const age = calculateAge(person.itariki_y_amavuko);
                      const stat = statusConfig[person.aho_ari] || {};
                      const tablePhotoUrl = getPhotoUrl(person.ifoto);
                      return (
                        <tr key={person.umuturage_id || idx}>
                          <td
                            className="text-center"
                            style={{ color: theme.primary, fontWeight: 700, fontSize: "0.78rem" }}
                          >
                            {indexOfFirst + idx + 1}
                          </td>
                          <td className="text-center">
                            {tablePhotoUrl ? (
                              <img
                                src={tablePhotoUrl}
                                alt={`${safeString(person.izina_ribanza)} ${safeString(person.izina_risoza)}`}
                                onError={handleImgError}
                                style={{
                                  width: "56px",
                                  height: "56px",
                                  borderRadius: "12px",
                                  objectFit: "cover",
                                  border: `2px solid ${theme.border}`,
                                  display: "block",
                                  margin: "0 auto",
                                }}
                              />
                            ) : (
                              <span
                                style={{
                                  color: "#9ca3af",
                                  fontSize: "0.78rem",
                                  fontWeight: 600,
                                }}
                              >
                                No Photo
                              </span>
                            )}
                          </td>
                          <td>
                            <div className="fw-semibold" style={{ color: theme.text }}>
                              {safeString(person.izina_ribanza)}{" "}
                              {safeString(person.izina_risoza)}
                            </div>
                          </td>
                          <td className="text-center">
                            <Badge
                              bg={
                                person.igitsina === "Gabo"
                                  ? "primary"
                                  : "danger"
                              }
                              pill
                            >
                              {safeString(person.igitsina)}
                            </Badge>
                          </td>
                          <td className="text-center">
                            {age !== null ? (
                              <Badge bg="info" pill>
                                {age}
                              </Badge>
                            ) : (
                              <span style={{ color: "#6b7280" }}>—</span>
                            )}
                          </td>
                          {!isSmall && (
                            <td className="td-nowrap">
                              <code
                                style={{
                                  color: "#d4d4f0",
                                  background: "#1e1e2c",
                                  padding: "0.2rem 0.45rem",
                                  borderRadius: "6px",
                                  fontSize: "0.76rem",
                                  fontWeight: 600,
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  letterSpacing: "0.3px",
                                  maxWidth: "160px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  verticalAlign: "middle",
                                }}
                                title={safeString(person.indangamuntu)}
                              >
                                {safeString(person.indangamuntu) || "—"}
                              </code>
                            </td>
                          )}
                          {!isSmall && (
                            <td className="td-nowrap">
                              {person.telefone ? (
                                <span style={{ color: "#34d399", whiteSpace: "nowrap", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                  <i className="bi bi-telephone-fill" style={{ flexShrink: 0 }}></i>
                                  <span>{safeString(person.telefone)}</span>
                                </span>
                              ) : (
                                <span style={{ color: "#6b7280" }}>—</span>
                              )}
                            </td>
                          )}
                          <td className="text-center">
                            <Badge bg={stat.color || "secondary"} pill>
                              {stat.label || safeString(person.aho_ari)}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge 
                              bg={person.imiterere_y_ubukwe === "Ingaragu" ? "secondary" : "success"} 
                              pill
                            >
                              {safeString(person.imiterere_y_ubukwe) || "Ingaragu"}
                            </Badge>
                          </td>
                          <td className="text-center">
                            {person.icyemezo_cy_ubukwe ? (
                              <a
                                href={`${API_BASE}/uploads/photos/${person.icyemezo_cy_ubukwe}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ display: "inline-block" }}
                              >
                                <img
                                  src={`${API_BASE}/uploads/photos/${person.icyemezo_cy_ubukwe}`}
                                  alt="Icyemezo cy'ubukwe"
                                  style={{
                                    width: "56px",
                                    height: "56px",
                                    borderRadius: "12px",
                                    objectFit: "cover",
                                    border: `2px solid ${theme.border}`,
                                    display: "block",
                                    margin: "0 auto",
                                    cursor: "pointer",
                                  }}
                                  title="Kanda urebe icyemezo cy'ubukwe"
                                />
                              </a>
                            ) : (
                              <span style={{ color: "#9ca3af", fontSize: "0.85rem" }}>
                                Nta cyemezo
                              </span>
                            )}
                          </td>
                          <td className="text-center td-nowrap" style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "flex", gap: "4px", justifyContent: "center", alignItems: "center", flexDirection: "row", flexWrap: "nowrap" }}>
                              <button
                                className="ibikorwa-btn ibikorwa-view"
                                onClick={() => handleViewDetails(person)}
                                title="Reba amakuru"
                              >
                                <i className="bi bi-eye"></i>
                                <span>Reba</span>
                              </button>
                              <button
                                className="ibikorwa-btn ibikorwa-edit"
                                onClick={() => handleEdit(person)}
                                title="Hindura"
                              >
                                <i className="bi bi-pencil"></i>
                                <span>Hindura</span>
                              </button>
                              <button
                                className="ibikorwa-btn ibikorwa-delete"
                                onClick={() => openDeleteModal(person.umuturage_id)}
                                title="Siba"
                              >
                                <i className="bi bi-trash"></i>
                                <span>Siba</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          )}

          {renderPagination()}
        </>
      )}

      {/* ═══════════ DELETE MODAL ═══════════ */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        size={isSmall ? "sm" : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {isSmall ? "Gusiba" : "Emeza Gusiba"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            className="mb-0"
            style={{ fontSize: isSmall ? "0.85rem" : "1rem" }}
          >
            Urashaka koko gusiba uyu muturage?{" "}
            <strong>Iki gikorwa ntikigarurwa.</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              flex: isMobile ? 1 : "none",
            }}
          >
            Bireke
          </Button>
          <Button
            variant="danger"
            onClick={confirmDelete}
            disabled={loading}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              flex: isMobile ? 1 : "none",
            }}
          >
            {loading ? "Tegereza..." : "Emeza, Siba"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════ ADD/EDIT MODAL ═══════════ */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size={isMobile ? undefined : "xl"}
        centered
        fullscreen={isSmall ? true : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i
              className={`bi bi-${
                editingId ? "pencil" : "person-plus"
              }-fill me-2`}
              style={{ color: theme.primary }}
            ></i>
            {editingId
              ? isSmall
                ? "Hindura"
                : "Hindura Amakuru"
              : isSmall
              ? "Andika Mushya"
              : "Andika Umuturage Mushya"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Izina Ribanza *</Form.Label>
                  <Form.Control
                    name="izina_ribanza"
                    value={form.izina_ribanza}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.izina_ribanza}
                    autoComplete="given-name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.izina_ribanza}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Izina Risoza *</Form.Label>
                  <Form.Control
                    name="izina_risoza"
                    value={form.izina_risoza}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.izina_risoza}
                    autoComplete="family-name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.izina_risoza}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Igitsina *</Form.Label>
                  <Form.Select
                    name="igitsina"
                    value={form.igitsina}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.igitsina}
                  >
                    <option value="">Hitamo...</option>
                    <option value="Gabo">Gabo</option>
                    <option value="Gore">Gore</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formErrors.igitsina}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Itariki y&#39;Amavuko *</Form.Label>
                  <DateOfBirthInput
                    name="itariki_y_amavuko"
                    value={form.itariki_y_amavuko}
                    onChange={handleInputChange}
                    className={`form-control${formErrors.itariki_y_amavuko ? " is-invalid" : ""}`}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.itariki_y_amavuko}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Indangamuntu</Form.Label>
                  <Form.Control
                    name="indangamuntu"
                    value={form.indangamuntu}
                    onChange={handleInputChange}
                    maxLength={16}
                    isInvalid={!!formErrors.indangamuntu}
                    inputMode="numeric"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.indangamuntu}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Telefoni</Form.Label>
                  <Form.Control
                    name="telefone"
                    value={form.telefone}
                    onChange={handleInputChange}
                    placeholder="07XXXXXXXX"
                    isInvalid={!!formErrors.telefone}
                    inputMode="tel"
                    autoComplete="tel"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.telefone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Aho Ari</Form.Label>
                  <Form.Select
                    name="aho_ari"
                    value={form.aho_ari}
                    onChange={handleInputChange}
                  >
                    {Object.entries(statusConfig).map(([k, v]) => (
                      <option key={k} value={k}>{v.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Urugo</Form.Label>
                  <Form.Select
                    name="household_id"
                    value={form.household_id}
                    onChange={handleInputChange}
                  >
                    <option value="">-- Hitamo urugo --</option>
                    {households.map((h) => (
                      <option key={h.urugo_id} value={h.urugo_id}>
                        {h.umukuru_w_urugo} {h.aho_batuye ? `(${h.aho_batuye})` : ""}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Ifoto y'umuturage</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                    onChange={handleFileChange}
                    isInvalid={!!formErrors.ifoto}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.ifoto}
                  </Form.Control.Feedback>
                  {(selectedFile?.name || form.ifoto) && (
                    <div className="mt-2">
                      <small className="text-muted">
                        {selectedFile ? "Ifoto yatoranijwe" : "Ifoto iriho"}: {selectedFile?.name || form.ifoto}
                      </small>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            {/* ── Marriage Status ── */}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Imiterere y'Ubukwe</Form.Label>
                  <Form.Select
                    name="imiterere_y_ubukwe"
                    value={form.imiterere_y_ubukwe}
                    onChange={handleInputChange}
                  >
                    <option value="Ingaragu">Ingaragu (Single)</option>
                    <option value="Yashyingiwe">Yashyingiwe (Married)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              {form.imiterere_y_ubukwe === "Yashyingiwe" && (
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <i className="bi bi-file-earmark-text-fill me-1" style={{ color: "#f59e0b" }}></i>
                      Icyemezo cy'Ubukwe <span style={{ color: "#ef4444" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) { setSelectedCertFile(null); return; }
                        if (file.size > 5 * 1024 * 1024) {
                          setFormErrors(p => ({ ...p, icyemezo_cy_ubukwe: "Dosiye ntigomba kurenza 5MB" }));
                          e.target.value = ""; return;
                        }
                        setSelectedCertFile(file);
                        setFormErrors(p => { const n = { ...p }; delete n.icyemezo_cy_ubukwe; return n; });
                      }}
                      isInvalid={!!formErrors.icyemezo_cy_ubukwe}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.icyemezo_cy_ubukwe}</Form.Control.Feedback>
                    <Form.Text style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" }}>
                      Injiza icyemezo cy'ubukwe (JPG, PNG, PDF — max 5MB)
                    </Form.Text>
                    {(selectedCertFile?.name || form.icyemezo_cy_ubukwe) && (
                      <div className="mt-1">
                        <small style={{ color: "#f59e0b" }}>
                          <i className="bi bi-paperclip me-1"></i>
                          {selectedCertFile ? selectedCertFile.name : form.icyemezo_cy_ubukwe}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}
            </Row>
            <div
              className="d-flex gap-2 mt-3"
              style={{
                flexDirection: isMobile ? "column" : "row",
                justifyContent: isMobile ? "stretch" : "flex-end",
              }}
            >
              <Button
                variant="secondary"
                onClick={() => setShow(false)}
                style={{
                  borderRadius: "12px",
                  minHeight: isMobile ? "48px" : "auto",
                  order: isMobile ? 2 : 1,
                }}
              >
                <i className="bi bi-x-lg me-2"></i>Hagarika
              </Button>
              <Button
                type="submit"
                className="btn-primary-modern"
                disabled={loading}
                style={{
                  minHeight: isMobile ? "48px" : "auto",
                  order: isMobile ? 1 : 2,
                }}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Tegereza...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-lg me-2"></i>
                    {editingId ? "Vugurura" : "Bika"}
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════ DETAILS MODAL ═══════════ */}
      <Modal
        show={showDetails}
        onHide={() => setShowDetails(false)}
        size={isMobile ? undefined : "lg"}
        centered
        fullscreen={isSmall ? true : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i
              className="bi bi-person-badge-fill me-2"
              style={{ color: theme.primary }}
            ></i>
            {isSmall ? "Amakuru" : "Amakuru arambuye"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPerson && (
            <div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                  gap: "1.5rem",
                  alignItems: "center",
                  marginBottom: "1.5rem",
                  padding: isSmall ? "1rem" : "1.25rem",
                  background:
                    `linear-gradient(145deg, ${theme.cardBg} 0%, ${theme.cardBgHover} 100%)`,
                  borderRadius: "20px",
                  border: `1px solid ${theme.border}`,
                }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {getPhotoUrl(selectedPerson.ifoto) ? (
                    <img
                      src={getPhotoUrl(selectedPerson.ifoto)}
                      alt={`${safeString(selectedPerson.izina_ribanza)} ${safeString(selectedPerson.izina_risoza)}`}
                      onError={handleImgError}
                      style={{
                        width: isSmall ? "170px" : "220px",
                        height: isSmall ? "200px" : "260px",
                        borderRadius: "24px",
                        objectFit: "cover",
                        border: `2px solid ${theme.border}`,
                        display: "block",
                        boxShadow: "0 24px 48px rgba(15,23,42,0.45)",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: isSmall ? "170px" : "220px",
                        height: isSmall ? "200px" : "260px",
                        borderRadius: "24px",
                        background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.6rem",
                        padding: "1rem",
                        textAlign: "center",
                        color: "#fff",
                        boxShadow: "0 24px 48px rgba(15,23,42,0.45)",
                      }}
                    >
                      <i className="bi bi-person-fill" style={{ fontSize: isSmall ? "2rem" : "2.6rem" }}></i>
                      <span style={{ fontSize: isSmall ? "0.85rem" : "0.95rem", fontWeight: 700 }}>
                        No Photo Available
                      </span>
                    </div>
                  )}
                </div>
                <div style={{ textAlign: isSmall ? "center" : "left" }}>
                  <div
                    style={{
                      fontSize: "0.74rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.14em",
                      color: theme.textMuted,
                      marginBottom: "0.75rem",
                    }}
                  >
                    Ifoto y'umwirondoro
                  </div>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: isSmall ? "1.15rem" : "1.5rem",
                      color: theme.text,
                      marginBottom: "0.5rem",
                    }}
                  >
                    {safeString(selectedPerson.izina_ribanza)}{" "}
                    {safeString(selectedPerson.izina_risoza)}
                  </div>
                  <div
                    style={{
                      color: theme.textMuted,
                      fontSize: "0.9rem",
                      marginBottom: "0.9rem",
                    }}
                  >
                    Iyi foto nini ifasha kumenya neza umuturage uri muri Amakuru arambuye.
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      justifyContent: isSmall ? "center" : "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                  <Badge
                    bg={
                      selectedPerson.igitsina === "Gabo"
                        ? "primary"
                        : "danger"
                    }
                    pill
                  >
                    {safeString(selectedPerson.igitsina)}
                  </Badge>
                  <Badge
                    bg={
                      statusConfig[selectedPerson.aho_ari]?.color ||
                      "secondary"
                    }
                    pill
                  >
                    {statusConfig[selectedPerson.aho_ari]?.label ||
                      safeString(selectedPerson.aho_ari)}
                  </Badge>
                </div>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr",
                  gap: "1rem",
                }}
              >
                {[
                  {
                    label: "Itariki y'Amavuko",
                    value: formatDateForDisplay(
                      selectedPerson.itariki_y_amavuko
                    ),
                    icon: "calendar-event",
                  },
                  {
                    label: "Imyaka",
                    value:
                      calculateAge(selectedPerson.itariki_y_amavuko) !== null
                        ? `${calculateAge(
                            selectedPerson.itariki_y_amavuko
                          )} y'amavuko`
                        : "—",
                    icon: "clock-history",
                  },
                  {
                    label: "Indangamuntu",
                    value: safeString(selectedPerson.indangamuntu) || "—",
                    icon: "credit-card-2-front",
                    mono: true,
                  },
                  {
                    label: "Telefoni",
                    value: safeString(selectedPerson.telefone) || "—",
                    icon: "telephone",
                    color: selectedPerson.telefone ? "#34d399" : undefined,
                  },
                  {
                    label: "Icyiciro cy'Ubudehe",
                    value:
                      safeString(selectedPerson.icyiciro_cy_imibereho) || "—",
                    icon: "bar-chart",
                  },
                  {
                    label: "Urugo",
                    value: safeString(selectedPerson.household_id) || "—",
                    icon: "house",
                  },
                  {
                    label: "Umukuru w'Urugo?",
                    value: selectedPerson.is_household_head ? "Yego" : "Oya",
                    icon: "person-badge",
                  },
                  {
                    label: "Imiterere y'Ubukwe",
                    value: safeString(selectedPerson.imiterere_y_ubukwe) || "Ingaragu",
                    icon: "heart-fill",
                    color: selectedPerson.imiterere_y_ubukwe === "Yashyingiwe" ? "#f59e0b" : undefined,
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      padding: "0.75rem",
                      background: theme.cardBgHover,
                      borderRadius: "12px",
                      border: `1px solid ${theme.border}`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginBottom: "0.35rem",
                      }}
                    >
                      <i
                        className={`bi bi-${item.icon}`}
                        style={{
                          color: theme.textMuted,
                          fontSize: "0.8rem",
                        }}
                      ></i>
                      <span
                        style={{
                          fontSize: "0.7rem",
                          color: theme.textMuted,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          fontWeight: 600,
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: isSmall ? "0.85rem" : "0.95rem",
                        color: item.color || theme.text,
                        fontFamily: item.mono ? "monospace" : "inherit",
                        fontWeight: 500,
                      }}
                    >
                      {safeString(item.value)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{ flexDirection: isMobile ? "column" : "row" }}
        >
          {selectedPerson && (
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowDetails(false);
                handleEdit(selectedPerson);
              }}
              style={{
                borderRadius: "12px",
                minHeight: isMobile ? "44px" : "auto",
                width: isMobile ? "100%" : "auto",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <i className="bi bi-pencil me-2"></i>Hindura
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => setShowDetails(false)}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              width: isMobile ? "100%" : "auto",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            <i className="bi bi-x-lg me-2"></i>Funga
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Abaturage;